<script>
	import AddressAutoComplete from "./AddressAutoComplete.svelte";

	export let idPrefix = null;
	export let label = "Address";
	export let address = null;
	export let disabled;
	export let required;
</script>

<AddressAutoComplete
	{idPrefix}
	{label}
	bind:addressValid={address.addressValid}
	bind:manualEntry={address.manualEntry}
	bind:googlePlaceJson={address.googlePlaceJson}
	bind:formattedAddress={address.formattedAddress}
	bind:premise={address.premise}
	bind:subpremise={address.subpremise}
	bind:street={address.street}
	bind:suburb={address.suburb}
	bind:state={address.state}
	bind:postcode={address.postcode}
	bind:country={address.country}
	bind:lat={address.lat}
	bind:lng={address.lng}
	bind:placeId={address.placeId}
	bind:url={address.googleMapsUrl}
	{disabled}
	{required}
></AddressAutoComplete>
